import { render, staticRenderFns } from "./HeaderTail.vue?vue&type=template&id=e85f98a4"
import script from "./HeaderTail.vue?vue&type=script&lang=ts"
export * from "./HeaderTail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports